import type { IconNode } from '../types';

/**
 * @name jar
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNCAzaDE2IiAvPgogIDxwYXRoIGQ9Ik01IDN2MS42YzAgLjgtLjIgMS42LS43IDIuMmwtLjcgMUMzLjIgOC40IDMgOS4yIDMgMTB2OGMwIDEuNyAxLjMgMyAzIDNoMTJjMS43IDAgMy0xLjMgMy0zdi04YzAtLjgtLjItMS42LS43LTIuMmwtLjctMWMtLjQtLjctLjYtMS40LS42LTIuMlYzIiAvPgogIDxwYXRoIGQ9Ik0zIDEzaDQiIC8+CiAgPHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjciIHg9IjciIHk9IjEwIiByeD0iMSIgLz4KICA8cGF0aCBkPSJNMTcgMTNoNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/jar
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const jar: IconNode = [
  ['path', { d: 'M4 3h16', key: 'vdt2yn' }],
  [
    'path',
    {
      d: 'M5 3v1.6c0 .8-.2 1.6-.7 2.2l-.7 1C3.2 8.4 3 9.2 3 10v8c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3v-8c0-.8-.2-1.6-.7-2.2l-.7-1c-.4-.7-.6-1.4-.6-2.2V3',
      key: 'rcoz42',
    },
  ],
  ['path', { d: 'M3 13h4', key: '1uxj7q' }],
  ['rect', { width: '10', height: '7', x: '7', y: '10', rx: '1', key: 'nkrqq8' }],
  ['path', { d: 'M17 13h4', key: 'ap2i9b' }],
];

export default jar;
